<h3 mat-dialog-title>{{data.title}}</h3>

<mat-dialog-content class="small-content">
    <p [innerHTML]="data.content"></p>
</mat-dialog-content>
<mat-dialog-actions>
    <button [attr.aria-label]="'cancel'" (click)="closeAndCancel()" class="btn btn-outline-secondary">
        {{data.cancelButton || 'Cancel'}}
    </button>
    <button [attr.aria-label]="'confirm'" (click)="closeAndConfirm()" class="btn btn-primary">{{data.confirmButton}}</button>
</mat-dialog-actions>
